import { LaneDirection, LaneInput } from '@kinetic-ui/data-layer';

export const getApproachLanes = (lanes: LaneInput[]) =>
  lanes
    ?.filter((lane) => lane.laneDirection === LaneDirection.Approach)
    .sort((laneA, laneB) =>
      (laneA.description as string)?.localeCompare(laneB.description as string, undefined, {
        sensitivity: 'base',
      })
    ) ?? [];
